module.exports = __webpack_public_path__ + "static/media/restartBtn.c93466a6.svg";